import React, { useEffect, useRef } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiTerminal } = FiIcons;

const getLineStyle = (log) => {
  if (log.includes('✅') || log.includes('COMPLETE') || log.includes('OK]')) return 'text-green-400';
  if (log.includes('WARNING') || log.includes('⚠')) return 'text-yellow-400';
  if (log.includes('FAIL') || log.includes('ERROR') || log.includes('ABORTING')) return 'text-red-400';
  if (log.includes('Phase') || log.includes('═') || log.includes('==')) return 'text-indigo-300 font-semibold';
  if (log.includes('[next.') || log.includes('[token.') || log.includes('[images]') ||
      log.includes('[card') || log.includes('[body.') || log.includes('[meta.') ||
      log.includes('[hyd.') || log.includes('[jsonld') || log.includes('[sweep.') ||
      log.includes('[hoverbg.') || log.includes('[canonical')) return 'text-blue-300';
  if (log.includes('[Config]')) return 'text-slate-400';
  if (log.startsWith('  -') || log.startsWith('  ✓') || log.startsWith('  ✗')) return 'text-slate-300';
  return 'text-slate-300';
};

const LogTerminal = ({ logs }) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [logs]);

  const now = new Date().toISOString().substring(11, 19);

  return (
    <div className="bg-[#0a0a0f] border border-slate-800 rounded-xl shadow-2xl overflow-hidden flex flex-col" style={{ minHeight: 420 }}>
      <div className="bg-slate-900/80 px-4 py-2.5 flex items-center gap-3 border-b border-slate-800">
        <div className="flex gap-1.5">
          <div className="w-3 h-3 rounded-full bg-red-500/80"></div>
          <div className="w-3 h-3 rounded-full bg-yellow-500/80"></div>
          <div className="w-3 h-3 rounded-full bg-green-500/80"></div>
        </div>
        <SafeIcon icon={FiTerminal} className="text-slate-500 text-sm" />
        <h3 className="text-xs font-mono text-slate-500 flex-1">pipeline-execution.log</h3>
        <span className="text-xs font-mono text-slate-600">{logs.length} lines</span>
      </div>

      <div ref={scrollRef} className="p-4 flex-1 overflow-y-auto font-mono text-xs leading-relaxed" style={{ maxHeight: 500 }}>
        {logs.length === 0 ? (
          <p className="text-slate-700 italic">$ awaiting execution command...</p>
        ) : (
          logs.map((log, index) => (
            <div key={index} className="mb-0.5 flex gap-2">
              <span className="text-slate-700 shrink-0 select-none">{now}</span>
              <span className={getLineStyle(log)}>{log}</span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default LogTerminal;